module.exports = __webpack_public_path__ + "static/media/Pan.bc231887.svg";